module.exports = __webpack_public_path__ + "img/Bein Medical.4b828b07.png";